import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { endpointsURL } from "../constants/endpointsURL";

@Injectable({
  providedIn: "root",
})
export class CVEService {
  env = environment.env;
  download = endpointsURL.download;

  constructor(private httpClient: HttpClient) {}

  public downloadFile(cve: string, numDoc: string) {
    let params = new HttpParams();
    params = params.append("codigoCve", cve);
    params = params.append("codigoSolicitud", numDoc);
    return this.httpClient.get(`${this.env}${this.download}certificado`, {
      params: params,
      responseType: "blob",
    });
  }
}
